import React, { useState } from 'react';
import { TabKeys, tabsData } from './constants';
import style from './SectionMobileWitsml.module.css';
import cn from 'classnames';
import Tag from '../UIkit/Tag';
import { useResize } from '../../utils/hooks';
import WitsmlList from './WitsmlList';

export default function SectionMobileWitsml() {
  const [activeTab, setActiveTab] = useState<TabKeys>('witsml');
  const { isScreen1024 } = useResize();

  return (
    <div className={style.container + ' dark'}>
      <div className={style.titlebox}>
        <h2>INNERICA WITSML</h2>
        {isScreen1024 && <Tag title="2 сценария развертывания" />}
      </div>
      {!isScreen1024 && (
        <p className={style.subtitle}>
          <span className={style.bold}>2</span> сценария развертывания:
        </p>
      )}
      <div className={style.tabs}>
        <button
          onClick={() => setActiveTab('witsml')}
          className={cn(style.tab, activeTab === 'witsml' && style.active)}
        >
          {tabsData.witsml.title}
        </button>
        <button
          onClick={() => setActiveTab('innerica')}
          className={cn(style.tab, activeTab === 'innerica' && style.active)}
        >
          {tabsData.innerica.title}
        </button>
      </div>

      <WitsmlList list={tabsData[activeTab].items} />
    </div>
  );
}
